import React, { FC } from 'react'

import { RepairOrderExpanded, VehicleEntry } from '../../sdk'
import { RepairOrderTabs } from '../SharedUI'

interface Props {
  vehicles?: VehicleEntry[]
  repairOrders: RepairOrderExpanded[] | undefined
}
export const RepairOrderByCustomer: FC<Props> = ({
  vehicles,
  repairOrders
}) => {
  return (
    <RepairOrderTabs
      repairOrders={repairOrders || []}
      colsForEstimate={['created', 'localId', 'vehicle', 'total']}
      colsForRepairOrder={[
        'created',
        'closedOn',
        'localId',
        'vehicle',
        'total',
        'status'
      ]}
      vehicles={vehicles}
      accounts={true}
    />
  )
}
